// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SeriesPlayScreen_container__toShu {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1rem;
    padding-top: 5rem !important;
    color: #ffffff;
  }
  
  .SeriesPlayScreen_card__cbjKd {
    display: flex;
    background-color: #111111;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);
  }
  
  .SeriesPlayScreen_imageSection__T5ygC {
    flex: 0 0 300px;
    position: relative;
  }
  
  .SeriesPlayScreen_coverImage__IEuWq {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .SeriesPlayScreen_contentSection__10qL5 {
    flex: 1 1;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .SeriesPlayScreen_title__tgkD8 {
    font-size: 2.5rem;
    font-weight: bold;
    margin: 0;
    color: #ffffff;
  }
  
  .SeriesPlayScreen_metadataSection__57K0S {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
  }
  
  .SeriesPlayScreen_metadataItem__MfZ6V {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .SeriesPlayScreen_metadataLabel__JCyC- {
    color: #999999;
    font-size: 0.9rem;
  }
  
  .SeriesPlayScreen_metadataValue__eSe1v {
    color: #ffffff;
    font-weight: 500;
    font-size: 0.9rem;
  }
  
  .SeriesPlayScreen_premiumBadge__6dTeA {
    background-color: #ff0000;
    color: white;
    font-size: 0.8rem;
    font-weight: bold;
    padding: 0.3rem 0.8rem;
    border-radius: 4px;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  
  .SeriesPlayScreen_description__Z7NQe {
    font-size: 1rem;
    line-height: 1.5;
    color: #cccccc;
    margin: 0;
  }
  
  .SeriesPlayScreen_redButton__yUr8e {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    background-color: #ef4444 !important;
    color: white;
    padding: 0.75rem 2rem;
    border-radius: 9999px;
    width: fit-content;
    cursor: pointer;
    border: none;
    font-size: 1rem;
    font-weight: 500;
    transition: background-color 0.2s;
  }
  
  .SeriesPlayScreen_redButton__yUr8e:hover {
    background-color: #cc0000;
  }
  
  .SeriesPlayScreen_playButton__QhkNg:disabled {
    background-color: #555555;
    cursor: not-allowed;
  }
  
  .SeriesPlayScreen_loading__gAERU {
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  /* Media Queries for Responsive Design */
  @media (max-width: 768px) {
    .SeriesPlayScreen_card__cbjKd {
      flex-direction: column;
    }
    
    .SeriesPlayScreen_imageSection__T5ygC {
      flex: 0 0 auto;
      height: 250px;
    }
    
    .SeriesPlayScreen_title__tgkD8 {
      font-size: 1.8rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/EpisodeScreen/Component/CSS/SeriesPlayScreen.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;EAC5C;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oCAAoC;IACpC,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,wCAAwC;EACxC;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,cAAc;MACd,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;EACF","sourcesContent":[".container {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 2rem 1rem;\n    padding-top: 5rem !important;\n    color: #ffffff;\n  }\n  \n  .card {\n    display: flex;\n    background-color: #111111;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);\n  }\n  \n  .imageSection {\n    flex: 0 0 300px;\n    position: relative;\n  }\n  \n  .coverImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .contentSection {\n    flex: 1;\n    padding: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n  \n  .title {\n    font-size: 2.5rem;\n    font-weight: bold;\n    margin: 0;\n    color: #ffffff;\n  }\n  \n  .metadataSection {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    margin-bottom: 1rem;\n  }\n  \n  .metadataItem {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n  \n  .metadataLabel {\n    color: #999999;\n    font-size: 0.9rem;\n  }\n  \n  .metadataValue {\n    color: #ffffff;\n    font-weight: 500;\n    font-size: 0.9rem;\n  }\n  \n  .premiumBadge {\n    background-color: #ff0000;\n    color: white;\n    font-size: 0.8rem;\n    font-weight: bold;\n    padding: 0.3rem 0.8rem;\n    border-radius: 4px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n  }\n  \n  .description {\n    font-size: 1rem;\n    line-height: 1.5;\n    color: #cccccc;\n    margin: 0;\n  }\n  \n  .redButton {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    background-color: #ef4444 !important;\n    color: white;\n    padding: 0.75rem 2rem;\n    border-radius: 9999px;\n    width: fit-content;\n    cursor: pointer;\n    border: none;\n    font-size: 1rem;\n    font-weight: 500;\n    transition: background-color 0.2s;\n  }\n  \n  .redButton:hover {\n    background-color: #cc0000;\n  }\n  \n  .playButton:disabled {\n    background-color: #555555;\n    cursor: not-allowed;\n  }\n  \n  .loading {\n    width: 100%;\n    height: 300px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  /* Media Queries for Responsive Design */\n  @media (max-width: 768px) {\n    .card {\n      flex-direction: column;\n    }\n    \n    .imageSection {\n      flex: 0 0 auto;\n      height: 250px;\n    }\n    \n    .title {\n      font-size: 1.8rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SeriesPlayScreen_container__toShu`,
	"card": `SeriesPlayScreen_card__cbjKd`,
	"imageSection": `SeriesPlayScreen_imageSection__T5ygC`,
	"coverImage": `SeriesPlayScreen_coverImage__IEuWq`,
	"contentSection": `SeriesPlayScreen_contentSection__10qL5`,
	"title": `SeriesPlayScreen_title__tgkD8`,
	"metadataSection": `SeriesPlayScreen_metadataSection__57K0S`,
	"metadataItem": `SeriesPlayScreen_metadataItem__MfZ6V`,
	"metadataLabel": `SeriesPlayScreen_metadataLabel__JCyC-`,
	"metadataValue": `SeriesPlayScreen_metadataValue__eSe1v`,
	"premiumBadge": `SeriesPlayScreen_premiumBadge__6dTeA`,
	"description": `SeriesPlayScreen_description__Z7NQe`,
	"redButton": `SeriesPlayScreen_redButton__yUr8e`,
	"playButton": `SeriesPlayScreen_playButton__QhkNg`,
	"loading": `SeriesPlayScreen_loading__gAERU`
};
export default ___CSS_LOADER_EXPORT___;
